import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { TrackingEvents } from '@estercare/ester-shared'
import { useEmitEvent } from './useEmitEvent'

export const useRouteAnalytics = () => {
  const location = useLocation()
  const emitEvent = useEmitEvent()
  const previousPathname = useRef<string>('')
  useEffect(() => {
    const currentPathname = location.pathname
    if (previousPathname.current === '/' && currentPathname !== '/') {
      //this is the only way we can detect a login, we check for the navidation from auth0s login page ("/") to the portal (not "/").
      emitEvent({
        eventType: TrackingEvents.USER_ACTION,
        action: 'user_logged_in',
      })
    }
    if (previousPathname.current !== currentPathname) {
      if (currentPathname) {
        emitEvent({
          eventType: TrackingEvents.PAGE_VIEW,
          eventPage: currentPathname,
        })
      }

      previousPathname.current = currentPathname
    }
  }, [location.pathname, emitEvent])
}
